import { useContext } from 'react'
import { CashflowEventsContext } from '../context'
import { currentYear } from '@utils/dateParser'
import * as Yup from 'yup'

export const formValidationSchema = () => {
  const { state: { userDetails, scenario, joint, participants } } = useContext(CashflowEventsContext)
  const { clientCurrentAge } = userDetails
  const { expectedAge } = scenario

  const baseSchema = {
    name: Yup.string()
      .required('A name for the event is required.')
      .typeError('Something is wrong with this event name. Try something different.'),
    amount: Yup.number()
      .required('An amount for the event is required.')
      .typeError('The amount needs to be a number.'),
    apply_annual_inflation: Yup.boolean(),
    annual_inflation: Yup.number().when('apply_annual_inflation', {
      is: true,
      then: schema => schema
        .required('You need to specify an annual inflation %.')
        .moreThan(-1, 'Annual inflation for cashflow events cannot be negative.')
        .typeError('The annual inflation can only be a number.'),
      otherwise: schema => schema
    })
  }

  if (joint) {
    const maxAgeRange = Math.max(
      ...participants
        .map((participant) => participant?.expectedAge - participant?.currentAge)
    )

    return Yup.object().shape({
      ...baseSchema,
      start_year: Yup.number()
        .required('Your event needs to happen at some year.')
        .moreThan(currentYear() - 1, 'This year is in the past.')
        .lessThan(currentYear() + maxAgeRange, 'This year seems too far ahead.')
        .typeError('The year can only be a number.'),
      end_year: Yup.number().when('recurring', {
        is: true,
        then: schema => schema
          .required('Your event needs to happen at some year.')
          .moreThan(Yup.ref('start_year'), 'This year should be after the start year.')
          .lessThan(currentYear() + maxAgeRange, 'This year seems too far ahead.')
          .typeError('The year can only be a number.'),
        otherwise: schema => schema
      }),
    })
  } else {
    return Yup.object().shape({
      ...baseSchema,
      start_age: Yup.number()
        .required('Your event needs to happen at some age.')
        .moreThan(clientCurrentAge - 1, 'This age is in the past.')
        .lessThan(expectedAge, 'This age seems too far ahead.')
        .typeError('Your age can only be a number.'),
      end_age: Yup.number().when('recurring', {
        is: true,
        then: schema => schema
          .required('Your event needs to happen at some age.')
          .moreThan(Yup.ref('start_age'), 'This age should be after the start age.')
          .lessThan(expectedAge, 'This age seems too far ahead.')
          .typeError('Your age can only be a number.'),
        otherwise: schema => schema
      }),
    })
  }
}
